import { ApiError, completeInitialAdminSetup } from '../../api/client';
import type { AuthSession } from '../../api/types';
import {
  InitialAdminSetupFailure,
  type InitialAdminSetupPort,
} from '../../features/tenant-setup/public';

export const initialAdminSetupHttpAdapter: InitialAdminSetupPort<AuthSession> = {
  async complete(input, csrfToken) {
    try {
      return await completeInitialAdminSetup(input, csrfToken);
    } catch (reason) {
      if (reason instanceof ApiError && reason.code === 'INITIAL_SETUP_COMPLETED') {
        throw new InitialAdminSetupFailure('already-completed', reason.message);
      }
      if (reason instanceof ApiError && reason.code === 'INITIAL_ADMIN_SETUP_EXPIRED') {
        throw new InitialAdminSetupFailure('expired', reason.message);
      }
      throw reason;
    }
  },
};
